import { render } from "./OthersMessage.vue?vue&type=template&id=51263c18&ts=true"
import script from "./OthersMessage.ts?vue&type=script&lang=ts&external"
export * from "./OthersMessage.ts?vue&type=script&lang=ts&external"

import "./OthersMessage.scss?vue&type=style&index=0&lang=css&external"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__